import React from 'react';
import PropTypes from 'prop-types';

const Origin = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Innanhúss";
      break;
    case 2:
      displayText = "Dómstóll g-mál";
      break;
    case 3:
      displayText = "Áskrifandi";
      break;
    case 4:
      displayText = "Gamla innsendingar vefþjónusta";
      break;
    case 5:
      displayText = "Innsendingar vefþjónusta";
      break;
    case 6:
      displayText = "Innsendingar vefþjónusta IL";
      break;
    case 7:
      displayText = "Vefur umboðsmaður";
      break;
    case 8:
      displayText = "Sýslumaður";
      break;
    case 9:
      displayText = "Lögbirtingur";
      break;
    case 10:
      displayText = "Innsent með öðrum leiðum.";
      break;
    case 11:
      displayText = "Dómstóll e-mál";
      break;
    default:
      displayText = "";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

Origin.propTypes = {
  data: PropTypes.number,
};

export default Origin;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Display/Origin.js